package com.futurions.portfolio.animations

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Color
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.animation
import com.varabyte.kobweb.compose.ui.modifiers.background
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onMouseEnter
import com.varabyte.kobweb.compose.ui.modifiers.onMouseLeave
import com.varabyte.kobweb.compose.ui.modifiers.onMouseMove
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.components.forms.CheckedState.Companion.from
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.overlay.PopupPlacementStrategy
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.animation.Keyframes
import com.varabyte.kobweb.silk.style.animation.toAnimation
import org.jetbrains.compose.web.css.AnimationTimingFunction
import org.jetbrains.compose.web.css.CSSLengthValue
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.Style

@Composable
fun SkillOrbitSection() {
    var rotationX: Double by remember { mutableStateOf(0.0) }
    var rotationY: Double by remember { mutableStateOf(0.0) }

    Column(
        modifier = Modifier
            .fillMaxWidth()
            .padding(top = 60.px),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        SpanText(
            "🚀 My Skills — Interactive Orbit",
            modifier = Modifier
                .fontSize(32.px)
                .color(org.jetbrains.compose.web.css.Color.white)
                .fontWeight(FontWeight.Bold)
                .padding(bottom = 40.px)
        )

        Box(
            modifier = Modifier
                .size(500.px)
                .styleModifier {
                    property("perspective", "900px")
                }
                .onMouseMove { event ->
                    val width = (event.target as org.w3c.dom.HTMLElement).offsetWidth.toDouble()
                    val height = (event.target as org.w3c.dom.HTMLElement).offsetHeight.toDouble()

                    val centerX = width / 2
                    val centerY = height / 2

                    // Convert offsetX/Y to Double properly
                    val offsetX = event.offsetX.toDouble() - centerX
                    val offsetY = event.offsetY.toDouble() - centerY

                    rotationY = offsetX / 20      // smooth movement
                    rotationX = -offsetY / 20
                }

                .transform {
                    rotateX(rotationX.deg)
                    rotateY(rotationY.deg)
                },
            contentAlignment = Alignment.Center
        ) {

            // ✅ OUTER NEON RING
            NeonOrbit(400.px) {
                OrbitIconAt("/tools/kotlin.png", top = 0.px, delay = 2)
                OrbitIconAt("/tools/java.png", right = 0.px, delay = 5)
                OrbitIconAt("/tools/python.png", bottom = 0.px, delay = 8)
                OrbitIconAt("/tools/unreal_engine.png", left = 0.px, delay = 12)
            }

            // ✅ INNER RING (Rotates opposite)
            NeonOrbit(260.px, reverse = true) {
                OrbitIconAt("/tools/gd_script.png", top = 100.px, delay = 15)
            }

            // ✅ CENTER PROFILE IMAGE
            Box(
                modifier = Modifier
                    .size(170.px)
                    .borderRadius(50.percent)
                    .background(Color.rgba(255, 255, 255, 0.05f))
                    .boxShadow(blurRadius = 35.px, color = Colors.Cyan.copy(alpha = 1)),
                contentAlignment = Alignment.Center
            ) {
                Image(
                    src = "/tools/Android.png",
                    description = "profile",
                    modifier = Modifier
                        .size(150.px)
                        .borderRadius(50.percent)
                        .objectFit(ObjectFit.Cover)
                )
            }
        }
    }
}


@Composable
fun OrbitIconAt(
    icon: String,
    top: CSSLengthValue? = null,
    bottom: CSSLengthValue? = null,
    left: CSSLengthValue? = null,
    right: CSSLengthValue? = null,
    delay: Int
) {
    Box(
        modifier = Modifier
            .size(80.px)
            .position(Position.Absolute)
            .then(if (top != null) Modifier.top(top) else Modifier)
            .then(if (bottom != null) Modifier.bottom(bottom) else Modifier)
            .then(if (left != null) Modifier.left(left) else Modifier)
            .then(if (right != null) Modifier.right(right) else Modifier)
    ) {
        OrbitSkill(icon, delay)
    }
}



// Orbit rotation animation


val OrbitRotate = Keyframes {
    from { Modifier.transform { rotate(0.deg) } }
    to { Modifier.transform { rotate(360.deg) } }
}

val OrbitReverse = Keyframes {
    from { Modifier.transform { rotate(360.deg) } }
    to { Modifier.transform { rotate(0.deg) } }
}

val GlowPulse = Keyframes {
    0.percent { Modifier.boxShadow(blurRadius = 15.px, color = org.jetbrains.compose.web.css.Color.cyan) }
    50.percent { Modifier.boxShadow(blurRadius = 35.px, color = org.jetbrains.compose.web.css.Color.cyan) }
    100.percent { Modifier.boxShadow(blurRadius = 15.px, color = Colors.Cyan.copy()) }
}

val Neon3DTilt = Keyframes {
    from {
        Modifier.styleModifier { property("transform", "rotateX(10deg) rotateY(0deg)") }
    }
    to {
        Modifier.styleModifier { property("transform", "rotateX(10deg) rotateY(360deg)") }
    }
}
@Composable
fun NeonOrbit(
    size: CSSLengthValue,
    reverse: Boolean = false,
    content: @Composable () -> Unit = {}
) {
    Box(
        modifier = Modifier
            .size(size)
            .borderRadius(50.percent)
            .border(2.px, LineStyle.Solid, Colors.Cyan)
            .position(Position.Relative)
            .animation(
                (if (reverse) OrbitReverse else OrbitRotate).toAnimation(
                    duration = 18.s,
                    timingFunction = AnimationTimingFunction.Linear,
                    iterationCount = AnimationIterationCount.Infinite
                )
            )
            .boxShadow(blurRadius = 25.px, color = Colors.Cyan.copy(alpha = 1)),
        contentAlignment = Alignment.Center
    ) {
        content()
    }
}





@Composable
fun OrbitSkill(icon: String, delay: Int) {
    Box(
        modifier = Modifier
            .size(65.px)
            .borderRadius(50.percent)
            .animation(
                GlowPulse.toAnimation(
                    duration = 3.s,
                    iterationCount = AnimationIterationCount.Infinite,
                    timingFunction = AnimationTimingFunction.EaseInOut,
                    delay = delay.s
                )
            ),
        contentAlignment = Alignment.Center
    ) {
        Image(
            src = icon,
            description = "",
            modifier = Modifier.size(55.px).borderRadius(50.percent)
        )
    }
}





@Composable
fun OrbitingSkill(icon: String, title: String, angle: Int = -1, size: Int = 60) {
    val hovered = remember { mutableStateOf(false) }

    val dynamicModifier = Modifier
        .size(size.px)
        .borderRadius(50.percent)
        .styleModifier {
            property("position", if (angle == -1) "absolute" else "absolute")
            property("top", if (angle == -1) "50%" else "50%")
            property("left", if (angle == -1) "50%" else "50%")

            if (angle != -1) {
                property("transform", "rotate(${angle}deg) translate(150px) rotate(-${angle}deg)")
            } else {
                property("transform", "translate(-50%, -50%)")
            }

            property("transition", "0.3s ease")
            property("background", "rgba(0,0,0,0.4)")
            property("backdrop-filter", "blur(6px)")
            property("border", "1px solid rgba(0,255,255,0.3)")
        }
        .onMouseEnter { hovered.value = true }
        .onMouseLeave { hovered.value = false }

    Box(dynamicModifier, contentAlignment = Alignment.Center) {
        Image(
            src = icon,
            description = title,
            modifier = Modifier
                .size((size - 8).px)
                .borderRadius(50.percent)
                .styleModifier {
                    if (hovered.value) {
                        property("transform", "scale(1.2)")
                        property("box-shadow", "0 0 20px rgba(0,255,255,0.6)")
                    }
                }
        )
    }
}
